{
  "drawer": {
    "title": "Hilfe zur Seite",
    "close": "Schließen"
  },
  "manual": {
    "title": "Handbuch",
    "subtitle": "Vollständige Dokumentation zu HydraHive2",
    "sections": {
      "concepts": "Konzepte",
      "usage": "Bedienung",
      "faq": "FAQ",
      "glossary": "Glossar"
    },
    "topics": {
      "onboarding": "Erste Schritte",
      "buddy": "Buddy (Assistent)",
      "butler": "Butler (Automationen)",
      "credentials": "Credentials",
      "architecture": "3-Ebenen-Architektur",
      "compaction": "Compaction",
      "mcp": "MCP-Protokoll",
      "tools": "Tools",
      "workspaces": "Workspaces",
      "dashboard": "Dashboard",
      "chat": "Chat",
      "agents": "Agenten",
      "projects": "Projekte",
      "llm": "LLM-Konfiguration",
      "mcp_servers": "MCP-Server",
      "system": "System",
      "faq_general": "Allgemein",
      "faq_errors": "Fehlermeldungen",
      "faq_setup": "Setup",
      "glossary_main": "Begriffe A-Z",
      "skills": "Skills",
      "memory": "Gedächtnis",
      "datamining": "Datamining",
      "communication": "Kommunikation",
      "teamchat": "Teamchat",
      "atelier": "Atelier (Medien)",
      "vms": "Virtuelle Maschinen",
      "containers": "Container",
      "users": "Benutzer",
      "patientenakte": "Meine Akte",
      "cryptoboard": "Cryptoboard",
      "notizbuch": "Notizbuch",
      "scratchpad": "Scratchpad",
      "deepresearch": "Deep Research",
      "homeassistant": "Home Assistant",
      "archiver": "Archiver",
      "blueprint": "Blueprint",
      "boardgames": "Brettspiele",
      "minigames": "Minigames",
      "musicplayer": "Musik",
      "tasks": "Aufgaben",
      "videoeditor": "Video-Editor",
      "zahnfee": "Zahnfee",
      "plugins": "Plugins",
      "federation": "Federation",
      "streaming": "Streaming",
      "extensions": "Extensions"
    }
  }
}